module.exports = __webpack_public_path__ + "img/back neck drop.87b47bcd.png";